<template>
  <div class="main">
    <div class="wait">
      <div class="wait-nr">
        <img src="./loading.gif">
        <p>{{msg}}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        msg: ''
      }
    }
  }
</script>

<style lang="less" scoped>
  .main {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1000;
  }

  .wait {
    position: fixed;
    top: 25%;
    z-index: 9999;
    text-align: center;
    margin: 0 auto;
    width: 100%;
  }

  .wait-nr {
    background-color: rgba(0, 0, 0, 0.7);
    /*background-color: #ece4de;*/
    border-radius: 5px;
    color: #fff;
    text-align: center;
    padding: 15px 20px;
    margin: 0 10px;
    display: inline-block;
  }

  .wait-nr img {
    width: 30px;
    margin-bottom: 5px;
  }

</style>



// WEBPACK FOOTER //
// src/components/base/wait/wait.vue